import React from 'react';
import {
  getDeliveryMethodIcon,
  getDeliveryPeriod,
} from '../../../utils/common.utils';

type TariffCellProps = {
  deliveryMethod: {
    method: string;
    deliveryPeriodFrom: number;
    deliveryPeriodTo?: number | null;
  };
};

export const TariffCell: React.FC<TariffCellProps> = ({ deliveryMethod }) => (
  <>
    <img
      src={getDeliveryMethodIcon(deliveryMethod.method)}
      className="me-3"
      alt=""
    />
    <div>{getDeliveryPeriod(deliveryMethod)}</div>
  </>
);
